// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"93de40d2","488":"636519d6","977":"ba0ca331"}[chunkId] + ".chunk.js";
};